import React from 'react';
import MethaqRefundForm from "./custom-forms/methaq-refund-form";
import {useMutation} from "react-query";
import {
    REQUEST_PAYMENT_REFUND
} from "../../../utils/graphql";
import {apollo} from "../../../utils/apollo";
import {toast} from "react-toastify";
import useModalStore from "../../../store/modal";
import use2FAStatus from "../../../hooks/use2FAStatus";
import Button from "../../../components/Button";
import DefaultRefundForm from "./custom-forms/default-refund-form";
import {clearCachedKey} from "../../../utils/helpers";
import {useNavigate} from "react-router-dom";

function RefundForm({payment}) {
    const {setModal, clearModal, hideModal, isOtpRequired, getOtpValue} = useModalStore();
    const [formData, setFormData] = React.useState({});
    const [customFormErrors, setCustomFormErrors] = React.useState([]);
                const navigate = useNavigate();

    const handleRefundAction = () => {
        if (!!customFormErrors?.length) {
            toast.error(customFormErrors[0]?.message ?? 'Please fill all required fields.');
            return;
        }

        setModal({
            isVisible: true,
            title: "Request a refund",
            description: "Are you sure you want to request a refund for this payment? This action cannot be undone.",
            otpRequired: false,
            confirmText: 'Request a refund',
            onConfirm: () => {
                requestPaymentRefundMutation.mutate();
                hideModal();
            },
            onCancel: () => {
                hideModal();
            },
        })
    }

    const requestPaymentRefundMutation = useMutation({
        mutationKey: 'request_payment_refund', mutationFn: async () => {
            const {data} = await apollo.mutate({
                mutation: REQUEST_PAYMENT_REFUND, variables: {
                    paymentUuid: payment.paymentUuid,
                    formData: !!formData ? JSON.stringify(formData) : null
                },
            });
            return data?.requestPaymentRefund;
        }, onSuccess: (data) => {
            if (data?.success) {
                toast.success(data?.message ?? 'Refund request has been sent.');
                navigate(`/merchant/payments/view/${payment.paymentUuid}`);
            } else {
                toast.error(data?.message ?? 'Refund request failed.');
            }
        }
    })

    // conditionally import the refund form
    const renderForm = () => {
        // methaq prod M135728300300999
        // samir dev,prod M862248712438901, M297763427187004
        if (['M135728300300999', 'M862248712438901', 'M297763427187004'].includes(payment?.merchant?.merchantUuid)) {
            return <MethaqRefundForm payment={payment} onFormChange={setFormData}
                                     setCustomFormErrors={setCustomFormErrors}/>;
        }
        return <DefaultRefundForm payment={payment} onFormChange={setFormData}
                                  setCustomFormErrors={setCustomFormErrors}/>;
    }

    return <div className="py-6">
        {payment?.isDuplicate && (
            <div className="mb-6 p-4 bg-orange-50 border border-orange-100 rounded-2xl">
                <p className="text-sm font-medium text-orange-800">
                    Refunds are disabled for this transaction as it is identified as a duplicate.
                </p>
            </div>
        )}
        {renderForm()}
        <Button secondary={false} onClick={handleRefundAction}
                disabled={requestPaymentRefundMutation.isLoading || !payment?.isRefundAutomated}>Request a
            Refund</Button>
    </div>;
}


export default RefundForm;